import axios from "axios";
import {urlApi} from "./api";
import {
  ApiResponseFromCMS,
  ClusterById,
} from "../pages/Dashboard/Dashboard.type";

const API_URL = `${urlApi}`;

export const fetchRadarData = async (filters: any): Promise<any> => {
  try {
    const queryParams = new URLSearchParams();
    if (filters.critical) queryParams.append("critical", filters.critical);
    if (filters.national) queryParams.append("national", filters.national);
    if (filters.growth_potential)
      queryParams.append("growth_potential", filters.growth_potential);
    if (filters.gpb) queryParams.append("gpb", filters.gpb);
    if (filters.invest_volume !== 0)
      queryParams.append("invest_volume", filters.invest_volume);
    if (filters.market_volume !== 0)
      queryParams.append("market_volume", filters.market_volume);

    const response = await axios.get(
      `${API_URL}/api/radar?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching radar data:", error);
    return null;
  }
};

// export const fetchDirectionData = async (id: number): Promise<any> => {
//   try {
//     const response = await axios.get(
//       `${API_URL || "http://212.233.96.105:8901"}/api/direction/${id}`
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching direction data:", error);
//     return null;
//   }
// };

export const fetchClusterData = async (id: number): Promise<any> => {
  try {
    const response = await axios.get(
      `${API_URL || "http://212.233.96.105:8901"}/api/cluster/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching cluster data:", error);
    return null;
  }
};

export const fetchTechnologyData = async (
  id: string,
  urlApiDataTehnology: string,
  apiKeyDataTehnology: string
): Promise<ApiResponseFromCMS<ClusterById> | null | undefined> => {
  try {
    if (urlApiDataTehnology && apiKeyDataTehnology) {
      const url = new URL(`${urlApiDataTehnology}/api/clusters/${id}`);
      url.searchParams.set("populate", "*");
      url.searchParams.set(
        "populate[technologies][filters][$or][0][molecule_only][$eq]",
        "false"
      );
      url.searchParams.set(
        "populate[technologies][filters][$or][1][molecule_only][$null]",
        "true"
      );

      const response = await fetch(url.href, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${apiKeyDataTehnology}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(
          `Failed to fetch technology data: ${response.statusText}`
        );
      }

      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error("Error fetching technology data:", error);
    return null;
  }
};

export const fetchAllTechnologiesList = async () => {
  try {
    const response = await axios.get(
      `https://gpb-radar.sandcloud.ru/api/radar?`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching technology data:", error);
    return null;
  }
};

export const fetchTechonologyOrganiztionData = async (
  technology: string
): Promise<any> => {
  try {
    const response = await axios.get(
      "https://drti-bkd.sandcloud.ru/api/search",
      {
        params: {
          technology: technology,
          filter_type: "commercial",
        },
        headers: {
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsInJvbGUiOiJhZG1pbiIsImV4cCI6MTkyMjI4NTQ0OH0.HlTKzAZ3sUuoVze0RdDK1QUvcoiWty0sac1UpeFrWnw",
        },
      }
    );
    return response.data
      .map((item: any) => {
        return {
          name: item?.attributes["Название компании"],
          webLink: item?.attributes["Адрес сайта"],
          summary: item?.attributes["Саммари карточки"],
        };
      })
      .slice(0, 5);
  } catch (error) {
    console.error("Error fetching technology organization data:", error);
    return [];
  }
};
